import Base from "../composition/Base";
import Rule, { RuleData, RuleResult} from "./Rule";


export interface RulesetData {
    rules: RuleData[]
}

export default class Ruleset {
    rulesetData: RulesetData
    element: Base
    constructor(rulesetData: RulesetData, element: Base) {
        this.rulesetData = rulesetData
        this.element = element
    }

    evaluate() {
        for(var i in this.rulesetData.rules) {
            const rule = new Rule(this.rulesetData.rules[i], this.element)
            const result = rule.evaluate()
            if(result == RuleResult.accept) {
                return result
            } else if(result == RuleResult.reject) {
                let errorCustom = new Error("Rule failed: " + rule.getReason());
                //@ts-ignore
                errorCustom.data = rule.getReason();

                throw errorCustom
            }
        }
    }
}